import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { processSteps } from '../data/content';

const Process = () => {
  return (
    <section className="section bg-light">
      <Container>
        <div className="section-title">
          <h2>Our Process</h2>
        </div>
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="process-timeline">
              {processSteps.map(step => (
                <div className="process-item" tabIndex={0} key={step.id}>
                  <div className="process-number">{step.id}</div>
                  <div className="process-content">
                    <div className="process-icon" aria-hidden="true"><step.icon /></div>
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Process;
